var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('div', [_c('screen-header', {
          attrs: {
            "title": _vm.$t(_vm.$route.meta.title),
            "history-mode": !_vm.isMobileOnly
          },
          on: {
            "navigate": _vm.navigateOnMobile
          }
        }, [_vm.$route.meta.help ? _c('help-link', {
          attrs: {
            "slot": "toolbar",
            "source": _vm.$route.meta.help
          },
          slot: "toolbar"
        }) : _vm._e()], 1), _vm.$route.meta.navigation ? _c('div', {
          class: _vm.$style.navigation
        }, [_c('navigation-controller')], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          class: _vm.$style.navigation
        }, [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": _vm.navigateOnDesktop
          }
        }), _c('navigation-controller')], 1)];
      },
      proxy: true
    }])
  })], 1), _vm.getAllWidgets ? _c('router-view', {
    attrs: {
      "widgets": _vm.getAllWidgets
    },
    on: {
      "remove": _vm.onRemove,
      "change-status": _vm.onChangeStatus,
      "submit": _vm.onManagingWidgetCreation
    }
  }) : _vm._e(), _c('widget-save-confirmation', {
    attrs: {
      "sender-fields": _vm.requiredSenderFields
    },
    on: {
      "confirmation": _vm.onConfirmationReceived
    },
    model: {
      value: _vm.isShownSaveConfirmation,
      callback: function callback($$v) {
        _vm.isShownSaveConfirmation = $$v;
      },
      expression: "isShownSaveConfirmation"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }